export const heroArticles = [
  {
    id: 'article-1',
    title: '某顶流艺人深夜密会',
    subtitle: '神秘女子酒店共度8小时',
    summary: '据知情人士爆料，某当红顶流男艺人近日被拍到与一位神秘女子在某五星级酒店同进同出，两人举止亲密，疑似新恋情曝光。该艺人的工作室目前尚未对此事作出回应。',
    category: '明星爆料',
    categorySlug: 'star-gossip',
    image: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20luxury%20hotel%20entrance%20at%20night%20with%20warm%20golden%20lighting%2C%20a%20luxury%20car%20parked%20outside%2C%20cinematic%20atmosphere%2C%20dramatic%20lighting%2C%20mysterious%20and%20elegant%20scene%2C%20soft%20bokeh%20background%2C%20editorial%20photography%20style%20with%20warm%20tones%20and%20dark%20shadows&width=800&height=1000&seq=hero-main-01&orientation=portrait',
    thumbImages: [
      'https://readdy.ai/api/search-image?query=Celebrity%20entering%20a%20luxury%20hotel%20at%20night%2C%20wearing%20a%20black%20cap%20and%20mask%2C%20surrounded%20by%20bodyguards%2C%20warm%20golden%20hotel%20lobby%20lights%2C%20paparazzi%20style%20photography%2C%20soft%20ambient%20glow%2C%20cinematic%20composition%20with%20shallow%20depth%20of%20field&width=600&height=400&seq=hero-thumb-01&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Mysterious%20woman%20in%20elegant%20dress%20walking%20through%20a%20luxury%20hotel%20corridor%2C%20back%20view%2C%20warm%20chandelier%20lighting%2C%20luxurious%20interior%20design%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20editorial%20fashion%20photography%20style&width=600&height=400&seq=hero-thumb-02&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Luxury%20hotel%20suite%20interior%20with%20dim%20romantic%20lighting%2C%20champagne%20glasses%20on%20a%20table%2C%20rose%20petals%2C%20elegant%20furniture%2C%20warm%20amber%20lighting%2C%20cinematic%20composition%2C%20luxury%20lifestyle%20photography&width=600&height=400&seq=hero-thumb-03&orientation=landscape'
    ],
    tags: ['顶流塌房', '恋情曝光', '独家爆料'],
    hotScore: 98532,
    publishDate: '2026-07-06',
    readTime: '5分钟'
  },
  {
    id: 'article-2',
    title: '知名网红直播翻车',
    subtitle: '假货风波持续发酵引众怒',
    summary: '拥有千万粉丝的某美妆网红近日在直播间推荐的"大牌平替"产品被粉丝扒出是三无产品，引发轩然大波。多名消费者反映使用后出现皮肤过敏症状，目前该网红已关闭评论区。',
    category: '网红黑料',
    categorySlug: 'influencer-drama',
    image: 'https://readdy.ai/api/search-image?query=A%20beauty%20influencer%20live%20streaming%20setup%20with%20ring%20light%20and%20makeup%20products%20on%20a%20desk%2C%20warm%20studio%20lighting%2C%20dramatic%20shadows%2C%20luxury%20makeup%20products%20scattered%20around%2C%20cinematic%20photography%2C%20warm%20rose%20and%20gold%20tones%2C%20editorial%20style&width=800&height=1000&seq=hero-main-02&orientation=portrait',
    thumbImages: [
      'https://readdy.ai/api/search-image?query=Close%20up%20of%20counterfeit%20makeup%20products%20on%20a%20white%20table%2C%20fake%20luxury%20brand%20packaging%2C%20investigative%20journalism%20style%2C%20bright%20clean%20lighting%2C%20product%20photography%20with%20dramatic%20shadows&width=600&height=400&seq=hero-thumb-04&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Angry%20consumers%20checking%20beauty%20products%20with%20magnifying%20glass%2C%20suspicious%20expressions%2C%20worried%20atmosphere%2C%20warm%20indoor%20lighting%2C%20editorial%20photography%20style&width=600&height=400&seq=hero-thumb-05&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Social%20media%20comment%20section%20filled%20with%20angry%20reactions%20on%20a%20smartphone%20screen%2C%20dramatic%20red%20and%20warm%20lighting%2C%20close%20up%20shot%2C%20digital%20culture%20photography&width=600&height=400&seq=hero-thumb-06&orientation=landscape'
    ],
    tags: ['假货风波', '直播翻车', '消费者维权'],
    hotScore: 87421,
    publishDate: '2026-07-05',
    readTime: '8分钟'
  }
];

export const trendingCards = [
  {
    id: 'card-1',
    title: '某女星离婚内幕曝光',
    subtitle: '财产分割细节惊人',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20courtroom%20interior%20with%20warm%20wooden%20furniture%2C%20legal%20documents%20on%20a%20desk%2C%20soft%20natural%20light%20streaming%20through%20windows%2C%20dramatic%20atmosphere%2C%20cinematic%20composition%2C%20warm%20amber%20and%20brown%20tones&width=600&height=600&seq=trend-01&orientation=squarish',
    hotScore: 76321
  },
  {
    id: 'card-2',
    title: '综艺录制现场冲突',
    subtitle: '两位导师当场翻脸',
    image: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20dramatic%20stage%20lighting%2C%20two%20people%20in%20heated%20argument%2C%20red%20and%20blue%20spotlights%20creating%20dramatic%20tension%2C%20reality%20show%20atmosphere%2C%20cinematic%20photography&width=600&height=600&seq=trend-02&orientation=squarish',
    hotScore: 68932
  },
  {
    id: 'card-3',
    title: '富豪家族争产风波',
    subtitle: '百亿遗产引发兄妹反目',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20mansion%20exterior%20with%20grand%20architecture%2C%20golden%20hour%20sunset%20lighting%2C%20dramatic%20shadows%2C%20wealth%20and%20power%20symbolism%2C%20cinematic%20wide%20shot%2C%20warm%20golden%20and%20dark%20tones&width=600&height=600&seq=trend-03&orientation=squarish',
    hotScore: 65418
  },
  {
    id: 'card-4',
    title: '知名导演潜规则爆料',
    subtitle: '多位女演员实名举报',
    image: 'https://readdy.ai/api/search-image?query=Film%20set%20with%20director%20chair%20and%20camera%20equipment%2C%20dramatic%20lighting%20with%20harsh%20shadows%2C%20mysterious%20atmosphere%2C%20behind%20the%20scenes%20movie%20production%2C%20cinematic%20photography%20with%20warm%20spotlight&width=600&height=600&seq=trend-04&orientation=squarish',
    hotScore: 62109
  },
  {
    id: 'card-5',
    title: '当红小生学历造假',
    subtitle: '粉丝脱粉回踩曝猛料',
    image: 'https://readdy.ai/api/search-image?query=University%20campus%20with%20modern%20architecture%20at%20sunset%2C%20graduation%20cap%20on%20a%20bench%2C%20dramatic%20golden%20light%2C%20symbolic%20composition%2C%20warm%20atmospheric%20tones%2C%20cinematic%20photography&width=600&height=600&seq=trend-05&orientation=squarish',
    hotScore: 58734
  }
];

export const gridItems = [
  {
    id: 'grid-1',
    title: '聊天记录泄露门',
    subtitle: '某男星暧昧聊天全曝光',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20chat%20messages%20with%20warm%20pink%20background%2C%20intimate%20texting%20atmosphere%2C%20soft%20romantic%20lighting%2C%20close%20up%20shot%2C%20modern%20digital%20communication%20concept&width=600&height=800&seq=grid-01&orientation=portrait',
    bgTint: 'pink'
  },
  {
    id: 'grid-2',
    title: '经纪人深夜密谈',
    subtitle: '疑似为艺人安排潜规则',
    image: 'https://readdy.ai/api/search-image?query=Two%20people%20having%20a%20secret%20conversation%20in%20a%20dimly%20lit%20restaurant%20corner%2C%20mint%20green%20ambient%20lighting%2C%20mysterious%20atmosphere%2C%20spy%20movie%20style%2C%20warm%20mint%20and%20dark%20green%20tones&width=600&height=800&seq=grid-02&orientation=portrait',
    bgTint: 'mint'
  },
  {
    id: 'grid-3',
    title: '女团成员内部霸凌',
    subtitle: '退团成员含泪揭露真相',
    image: 'https://readdy.ai/api/search-image?query=Kpop%20style%20dance%20practice%20room%20with%20mirrors%2C%20empty%20and%20lonely%20atmosphere%2C%20soft%20gray%20lighting%2C%20dramatic%20shadows%2C%20emotional%20and%20melancholic%20mood%2C%20warm%20gray%20and%20silver%20tones&width=600&height=800&seq=grid-03&orientation=portrait',
    bgTint: 'gray'
  },
  {
    id: 'grid-4',
    title: '豪门婚礼变闹剧',
    subtitle: '新郎前女友大闹现场',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20wedding%20venue%20in%20chaos%2C%20overturned%20tables%20and%20chairs%2C%20dramatic%20atmosphere%2C%20warm%20golden%20chandelier%20lighting%2C%20wedding%20decorations%20scattered%2C%20cinematic%20composition%20with%20warm%20amber%20and%20brown%20tones&width=600&height=800&seq=grid-04&orientation=portrait',
    bgTint: 'amber'
  }
];

export const categories = [
  { name: '明星爆料', slug: 'star-gossip', icon: 'ri-star-line' },
  { name: '网红黑料', slug: 'influencer-drama', icon: 'ri-user-smile-line' },
  { name: '聊天记录', slug: 'chat-leaks', icon: 'ri-message-2-line' },
  { name: '每日大赛', slug: 'daily-contest', icon: 'ri-fire-line' },
  { name: '综艺翻车', slug: 'show-fails', icon: 'ri-tv-line' },
  { name: '豪门恩怨', slug: 'rich-drama', icon: 'ri-vip-crown-line' },
];

export const faqItems = [
  {
    question: '51吃瓜app是什么？',
    answer: '51吃瓜app是一个专注于娱乐八卦、网红爆料、明星黑料等热门资讯的聚合平台。我们实时汇聚全网最热门的吃瓜内容，为用户提供最新、最全、最快的娱乐资讯服务。无论是明星塌房、网红翻车还是聊天记录泄露，您都能在这里第一时间获取。'
  },
  {
    question: '51吃瓜app的内容来源是什么？',
    answer: '我们的内容来源于全网公开信息、用户投稿以及专业娱乐记者的一手报道。所有内容均经过编辑团队的审核与整理，确保信息的真实性和时效性。我们致力于为用户提供高质量的吃瓜体验。'
  },
  {
    question: '如何下载51吃瓜app？',
    answer: '您可以通过本网站提供的官方下载链接获取51吃瓜app。我们提供iOS和Android两个版本的下载，请认准官方渠道下载，避免下载到仿冒应用。建议收藏本站以获取最新下载地址。'
  },
  {
    question: '51吃瓜app是否收费？',
    answer: '51吃瓜app完全免费使用！我们不收取任何费用，所有内容均可免费浏览。您只需下载安装即可畅享全部功能，随时随地获取最新最热的吃瓜资讯。'
  },
  {
    question: '如何投稿爆料？',
    answer: '如果您有独家爆料线索，欢迎通过网站底部的联系方式或App内的投稿通道向我们提供信息。我们承诺对投稿人信息严格保密，并对高质量爆料给予相应奖励。'
  }
];